import { useMsal } from '@azure/msal-react';
import { Avatar, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import MSLogo from '../img/ms-logo.svg';
import { userPermissionsSelector } from '../state';
import { loginRedirectRequest } from '../config/auth.config';

const LoadingWrapper = styled('div')(({ theme }) => ({
  margin: theme.spacing(1),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

const AvatarStyled = styled(Avatar)(({ theme }) => ({
  margin: theme.spacing(1),
  backgroundColor: theme.palette.primary.main,
}));

const ErrorDescription = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(4),
  whiteSpace: 'pre-line',
  textAlign: 'center',
}));

const ProgressAvatar = styled(CircularProgress)(() => ({
  position: 'absolute',
  zIndex: 1,
}));

const ButtonStyled = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(1),
  background: theme.palette.background.paper,
  borderRadius: 0,
  textTransform: 'none',
  fontSize: 15,
  fontWeight: 500,
}));

const SignIn = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { instance, inProgress } = useMsal();
  const { loading: userPermissionsLoading, failure } = useSelector(userPermissionsSelector);
  const loading = inProgress !== 'none' || userPermissionsLoading;

  const login = () => instance.loginRedirect(loginRedirectRequest);
  const handleClickLogout = () => {
    instance.setActiveAccount(null);
    instance.clearCache();
    navigate(0);
  };

  return (
    <>
      <LoadingWrapper>
        {loading && <ProgressAvatar size={48} color="primary" />}
        <AvatarStyled>
          <LockOutlinedIcon />
        </AvatarStyled>
      </LoadingWrapper>
      <Typography component="h1" variant="h5">
        Conciliations
      </Typography>
      {failure ? (
        <>
          <ErrorDescription variant="subtitle1" color="text.secondary">
            {t('login.labels.error')}
          </ErrorDescription>
          <ButtonStyled disabled={loading} variant="outlined" onClick={handleClickLogout}>
            {t('layout.header.menu.logout')}
          </ButtonStyled>
        </>
      ) : (
        <ButtonStyled onClick={login} startIcon={<MSLogo />} variant="outlined" disabled={loading}>
          {t('login.labels.signInWithMS')}
        </ButtonStyled>
      )}
    </>
  );
};

export default SignIn;
